export default function HeaderSkeleton() {
  return (
    <div className="sticky top-0 z-50 w-full bg-white">
      <header
        className="z-header grid h-auto w-full auto-cols-fr justify-center border-b border-[#EFEFEF] bg-header"
        data-cy="Header-root"
      >
        <div className="h-8 animate-pulse bg-primary" />
        <div className="lg_h-30 border-0 shadow-sm relative z-header mx-auto flex h-[60px] w-full content-center items-center justify-between px-0 lg_h-[150px] lg_px-[5%]">
          <div className="flex w-full items-center justify-between">
            <div className="flex space-x-4"></div>
            <div className="h-[48px] w-[216px] animate-pulse bg-[#f0f0f0]" />
            <div className="flex space-x-4">
              <div className="h-8 w-8 animate-pulse rounded-full bg-[#f0f0f0]" />
              <div className="h-8 w-8 animate-pulse rounded-full bg-[#f0f0f0]" />
              <div className="h-8 w-8 animate-pulse rounded-full bg-[#f0f0f0]" />
            </div>
          </div>
        </div>
      </header>
    </div>
  )
}
